import { array } from "prop-types";
import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { USER_WARNING_LETTER } from "../config/apiEndPoint";
import { GET, POST, PUT } from "config/api.config";

export const submitUserWarningLetterFilterData = async (data = array()) => {
  try {
    const response = await POST(USER_WARNING_LETTER.SUBMIT_FILTER_DATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const fetchUserWarningLetterTableAndFilterSchema = async (data = array()) => {
  try {
    const response = await GET(USER_WARNING_LETTER.GET_WARNING_LETTER_SCHEMA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const addUserWarningLetter = async (data = array()) => {
  try {
    const response = await POST(USER_WARNING_LETTER.GET_WARNING_LETTER_LIST, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const updateUserWarningLetter = async (id, data = array()) => {
  try {
    const url = `${USER_WARNING_LETTER.GET_WARNING_LETTER_LIST}/${id}`;
    const response = await PUT(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
